'use client'
import { storyblokEditable } from '@storyblok/react'
import { type StoryblokRichTextNode } from '@storyblok/richtext'
import { assignInlineVars } from '@vanilla-extract/dynamic'
import { useId, useMemo } from 'react'
import { Accordion } from 'ui/src/components/Accordion/Accordion'
import { Text } from 'ui/src/components/Text/Text'
import { tokens } from 'ui/src/theme/tokens.css'
import { RichText } from '@/components/RichText/RichText'
import { paragraphColor } from '@/components/RichText/RichText.css'
import { type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { renderRichTextToJsx } from './RichTextBlock/richTextReactRenderer'

export type AccordionItemBlockProps = SbBaseBlockProps<{
  title: string
  body: StoryblokRichTextNode
}> & { openItem?: string }

export const AccordionItemBlock = ({ blok, openItem }: AccordionItemBlockProps) => {
  const defaultId = useId()
  const content = useMemo(() => renderRichTextToJsx(blok.body), [blok.body])
  const value = blok._uid || defaultId

  return (
    <Accordion.Item value={value} {...storyblokEditable(blok)}>
      <Accordion.HeaderWithTrigger>
        <Text as="span" size={{ _: 'md', md: 'lg' }}>
          {blok.title}
        </Text>
      </Accordion.HeaderWithTrigger>
      <Accordion.Content open={openItem === value} asChild={true}>
        <RichText
          style={assignInlineVars({
            [paragraphColor]: tokens.colors.text.opaque.accordion,
          })}
        >
          {content}
        </RichText>
      </Accordion.Content>
    </Accordion.Item>
  )
}
AccordionItemBlock.blockName = 'accordionItem'
